var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import cx from 'classnames';
import styles from './Breadcrumbs.module.scss';
/**
 * @tdr
 * @tdr-deprecated-props: ariaLabel,backTo,breadcrumbs,linkElement,prefixLabel,prefixPath,white
 * @tdr-deprecated-date: 2022-06-01
 */
export function Breadcrumbs(_a) {
    var _b;
    var className = _a.className, _c = _a.light, light = _c === void 0 ? false : _c, children = _a.children, props = __rest(_a, ["className", "light", "children"]);
    return (React.createElement("nav", __assign({}, props, { className: cx(styles.breadcrumbs, className, (_b = {},
            _b[styles.light] = light,
            _b)), "aria-label": "Breadcrumb" }),
        React.createElement("div", { className: styles.crumbs }, children)));
}
//# sourceMappingURL=Breadcrumbs.js.map